module.exports = "/static/assets/431fd7ca74b8eb8ed49519771b2334e6.png";